var _ = require('underscore'),
  Promise = require('bluebird'),
  React = require('react'),
  Dropdown = require('react-bootstrap/lib/Dropdown'),
  MenuItem = require('react-bootstrap/lib/MenuItem'),
  Glyphicon = require('react-bootstrap/lib/Glyphicon'),
  ClassNames = require('classnames');

var CustomPropTypes = require('../types.jsx'),
  Utils = require('../utils.jsx');

var TracksMenu = React.createClass({
  propTypes: {
    role: React.PropTypes.string.isRequired,
    track: React.PropTypes.number,
    playlist: React.PropTypes.number,
    playlists: CustomPropTypes.PlaylistsType,
    onSelect: React.PropTypes.func,

    className: CustomPropTypes.ClassNameType
  },
  render: function () {
    var playlist = this.props.playlists[this.props.playlist].playlist,
      track = playlist[this.props.track],
      playlist_menu_items = _.map(playlist, function (track, index) {
        return (
          <MenuItem key={index} eventKey={index}>
            <div className='player-track'>
              {(track.image) ? <img src={track.image} alt={track.name} /> : <Glyphicon glyph='play' />}
              {' '}
              {track.name}
            </div>
          </MenuItem>
        );
      });
    var className = Utils.ClassNames('player-tracks', this.props.className);
    return (
      <Dropdown id='player-tracks' className={ClassNames(className)} dropup onSelect={this.onSelect}>
        <a className='player-track' bsRole='toggle'>
          {(track.image) ? <img src={track.image} alt={track.name} /> : null}
          {track.name}
        </a>
        <Dropdown.Menu className='player-tracks'>
          {playlist_menu_items}
        </Dropdown.Menu>
      </Dropdown>
    );
  },

  onSelect: function (e, track) {
    this.props.onSelect(track);
  }
});

module.exports = TracksMenu;



// WEBPACK FOOTER //
// ./src/app/components/track/menu.jsx